import {WalletFreezeModalForm} from './WalletFreezeModalForm'

const WalletFreezeModalFormWrapper = ({setOpenFreezeWalletModal, getUser, user}) => {
    return <WalletFreezeModalForm setOpenFreezeWalletModal={setOpenFreezeWalletModal} getUser={getUser} user={user} />
}

export {WalletFreezeModalFormWrapper}
